import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PaginationProps {
  page: number;
  pageSize: number;
  count: number;
  /** Libellé pluriel des éléments affichés (« consultations », « factures »…) */
  label: string;
  onChange: (page: number) => void;
}

/** Pied de tableau paginé — à placer dans un `.son-table-wrap`. */
const Pagination: React.FC<PaginationProps> = ({ page, pageSize, count, label, onChange }) => {
  const totalPages = Math.ceil(count / pageSize);
  if (totalPages <= 1) return null;

  return (
    <nav className="son-pager" aria-label="Pagination">
      <span>
        <strong className="text-[color:var(--text)] tabular-nums">
          {(page - 1) * pageSize + 1}–{Math.min(page * pageSize, count)}
        </strong>{' '}
        sur <span className="tabular-nums">{count}</span> {label}
      </span>
      <div className="flex items-center gap-2">
        <button onClick={() => onChange(Math.max(1, page - 1))} disabled={page === 1}>
          <ChevronLeft className="h-4 w-4" aria-hidden /> Précédent
        </button>
        <span className="px-1 tabular-nums">
          Page {page} / {totalPages}
        </span>
        <button onClick={() => onChange(Math.min(totalPages, page + 1))} disabled={page === totalPages}>
          Suivant <ChevronRight className="h-4 w-4" aria-hidden />
        </button>
      </div>
    </nav>
  );
};

export default Pagination;
